<template>

    <div>
        <div v-if="sitio" class="site-bg" :style="{'background-image': `url(${sitio.foto_url})`}"></div>
        <div class="site-content">
            <router-view />
        </div>
    </div>

</template>

<script>
    export default {
        name: 'SiteLayout',

        computed: {
            sitio() {
                return this.$store.getters['sitio/sitio'];
            },
        },

        methods:{},

        created() {
            if(this.sitio === null || this.sitio.url !== this.$route.params.sitio){
                this.$store.dispatch('sitio/fetchContent', this.$route.params.sitio).then(() => {
                    document.title = this.sitio.nombre;
                });
            }
        }
    }
</script>

<style scoped>
.site-bg {
    position: fixed;
    inset: 0;
    background-size: cover;
    background-position: center center;
    z-index: -1;
}
.site-bg::after {
    content: '';
    position: absolute;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.3);
}
.site-content {
    max-width: 550px;
    margin: 0 auto;
}
</style>